import React from 'react'
import ApplyForInsurance from '../../../views/Insurance/ApplyForInsurance'

const InsuranceApplication = () => {
  return (
    <ApplyForInsurance/>
  )
}

export default InsuranceApplication